import { CssProperties, ICssPropertiesObject, ICssProperty } from "../models/css-property";

export class ElementStyleService {

    public setStyle(element: HTMLElement, selector: string, properties: ICssProperty[]): void {
        const styleTagId = `${element.id}-styles`;
        let styleElement = element.querySelector<HTMLStyleElement>(`style#${styleTagId}`);

        if (!styleElement) {
            styleElement = document.createElement("style");
            styleElement.id = styleTagId;
            element.appendChild(styleElement);
        }

        const styleContent = `${selector} { ${properties
            .filter(property => property.value !== undefined)
            .map(CssProperties.format)
            .join("; ")} } `;

        const regex = new RegExp(`${selector.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\s*\\{[^}]*}\\s*`, "gs");
        let textContent = styleElement.textContent ?? "";
        textContent = textContent.replace(regex, "");
        textContent += styleContent;

        styleElement.textContent = textContent;
    }

    public setStyleObject(element: HTMLElement, selector: string, properties: ICssPropertiesObject): void {
        const cssProperties = new CssProperties().addObj(properties);
        this.setStyle(element, selector, cssProperties.data);
    }

    public deleteAllStyles(element: HTMLElement): void {
        const styleTagId = `${element.id}-styles`;
        const styleElement = element.querySelector<HTMLStyleElement>(`style#${styleTagId}`);
        styleElement?.remove();
    }

    public clearStyle(element: HTMLElement, selector: string): void {
        const styleTagId = `${element.id}-styles`;
        const styleElement = element.querySelector<HTMLStyleElement>(`style#${styleTagId}`);
        if (styleElement?.textContent) {
            const regex = new RegExp(`${selector.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\s*\\{[^}]*}\\s*`, "gs");
            styleElement.textContent = styleElement.textContent.replace(regex, "");
        }
    }

}
